/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `auto` - auto
 * * `manual` - manual
 * @export
 */
export const FindingSourceEnum = {
  auto: 'auto',
  manual: 'manual',
} as const;
export type FindingSourceEnum = (typeof FindingSourceEnum)[keyof typeof FindingSourceEnum];

export function instanceOfFindingSourceEnum(value: any): boolean {
  for (const key in FindingSourceEnum) {
    if (Object.prototype.hasOwnProperty.call(FindingSourceEnum, key)) {
      if ((FindingSourceEnum as Record<string, FindingSourceEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FindingSourceEnumFromJSON(json: any): FindingSourceEnum {
  return FindingSourceEnumFromJSONTyped(json, false);
}

export function FindingSourceEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingSourceEnum {
  return json as FindingSourceEnum;
}

export function FindingSourceEnumToJSON(value?: FindingSourceEnum | null): any {
  return value as any;
}
